import React from 'react';
import RMSChip from 'features/shared/components/chips/RMSChip';

const SectionCard = ({ className = '', children, label = '' }) => {
  return (
    <>
      <section className={`pd-section ${className}`}>
        <RMSChip color="info" label={label} className="pd-section__chip" />
        <div className="pd-section__body">{children}</div>
      </section>
    </>
  );
};

export default SectionCard;
